module.exports = __webpack_public_path__ + "static/media/logo_land.b9d1aa75.png";